/* The in-app channel (docs/13 §2.5): a card on Home and a Messages inbox. Seen and tapped go back as events. */
import { api } from './api.js';

export interface InboxMessage { id: string; title: string | null; body: string; link: string | null; code: string | null; cta: string | null; at: string; seen: boolean; tapped: boolean; kind: string; source: string }

export async function loadInbox(markSeen = false): Promise<{ messages: InboxMessage[]; unseen: number }> {
  return api<{ messages: InboxMessage[]; unseen: number }>(`/api/me/messages${markSeen ? '?mark=seen' : ''}`);
}

/** Record the tap and say where to go. */
export async function tapMessage(id: string): Promise<{ link: string | null; code: string | null }> {
  return api<{ link: string | null; code: string | null }>(`/api/me/messages/${id}/tapped`, { body: {} }).catch(() => ({ link: null, code: null }));
}

export const relTime = (iso: string): string => {
  const d = new Date(iso), now = Date.now();
  const mins = Math.round((now - d.getTime()) / 60000);
  if (mins < 2) return 'now';
  if (mins < 60) return `${mins} min ago`;
  const h = Math.round(mins / 60);
  if (h < 24) return `${h} h ago`;
  return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'Europe/London' });
};
